import React from "react";
import general_helper, {dateFormatter} from "../../helpers/general_helper";
import DeliveryMetaCard from "../MetaCard";

const TimelapseItem = ({data}) => {
    return (
        <>
            <li className="event">
                <h6>{general_helper.displayCurrentDeliveryStatus(data.timelapses.status)}</h6>
                <small>{dateFormatter(data.timelapses.date)}</small>
                {/*Only show if its pick up*/}
                {
                    data.timelapses.status === general_helper.deliveryStatesKeys[1] ?
                        <DeliveryMetaCard
                            data={{
                                title: data.deliveryItem.agent.name,
                                subTitle: data.deliveryItem.agent.phone
                            }}/> : <p>{data.timelapses.message}</p>
                }
            </li>
        </>
    )
};

export default TimelapseItem;
